import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from './config/env';
import { setUserInfo } from './reducer/user';
import { useDispatch } from 'react-redux';
import { checkAuthApi } from "./api/auth";
import { useMediaQuery } from 'react-responsive';
import { useEffect } from "react";
declare module 'jwt-decode' {
	export interface JwtPayload {
			upn: string;
			name: string;
      preferred_username: string;
      given_name: string;
			oid: string;
    }
}

export function openSidebar() {
    if (typeof window !== 'undefined') {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
    }
  }
  
export function closeSidebar() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--SideNavigation-slideIn');
    document.body.style.removeProperty('overflow');
  }
}

export function toggleSidebar() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue('--SideNavigation-slideIn');
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
}
  
export function openMessagesPane() {
  if (typeof window !== 'undefined') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.setProperty('--MessagesPane-slideIn', '1');
  }
}
  
export function closeMessagesPane() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--MessagesPane-slideIn');
    document.body.style.removeProperty('overflow');
  }
}
  
export function toggleMessagesPane() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--MessagesPane-slideIn');
      if (slideIn) {
        closeMessagesPane();
      } else {
      openMessagesPane();
    }
  }
}
  
export const findUserRoleByEmail = async (email: string | null): Promise<string | null> => {
  if (email === null) return null;
  const api_host = API_BASE_URL;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 7000); // 타임아웃 7초

  try {
    const response = await fetch(`${api_host}/acl`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem("idToken")}`,
      },
      credentials: 'include',
      mode: 'cors',
      body: JSON.stringify({ email }),
      signal: controller.signal,
    });

    if (!response.ok) return "Not Authorized";

    const bodyText = (await response.text()).trim();
    if (!bodyText) return null; // 본문이 없어도 오류 대신 null 반환
    if (bodyText.toUpperCase() === "UNAUTHORIZED") return null;
    return bodyText;
  } catch (err: any) {
    // 네트워크 오류, 타임아웃(AbortError) 등도 모두 정상 종료 처리
    return null;
  } finally {
    clearTimeout(timeoutId);
  }
};

export const checkUserAccount = (token: string) => {
  const decodedToken = jwtDecode(token);
  return decodedToken;
};
  
export const useCheckUserRoles = (idToken: string | null) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const checkRoles = async () => {
      if (!idToken) return;

      const tokenInfo = checkUserAccount(idToken);
      const roleByAccount = await findUserRoleByEmail(tokenInfo.upn);

      if (roleByAccount != null && roleByAccount !== "Not Authorized") {
        dispatch(setUserInfo({
          email: tokenInfo.preferred_username || "",
          name: tokenInfo.name,
          username: tokenInfo.given_name,
          uid: tokenInfo.oid,
          role: roleByAccount,
        }));
      } else if(roleByAccount === "Not Authorized"){
        dispatch(setUserInfo({
          email: "",
          name: "",
          username: "",
          uid: "",
          role: "Not Authorized",
        }));
        console.log("Check UserInfo: Not Authorized");
      } else {
        console.log("Check UserInfo: Unexpected Error occurred");
      }
    };

    checkRoles();
  }, [idToken, dispatch]);
};

export function generateRandomString(length: number) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export const CheckMobile = () => {
	return useMediaQuery({
		query: '(max-width: 600px)',
	});
};